import { render } from "./leaveHistory.vue?vue&type=template&id=742e3e5e&scoped=true"
import script from "./leaveHistory.vue?vue&type=script&lang=js"
export * from "./leaveHistory.vue?vue&type=script&lang=js"

import "./leaveHistory.vue?vue&type=style&index=0&id=742e3e5e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-742e3e5e"]])

export default __exports__